import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-emp-sep-auth-form',
  templateUrl: './emp-sep-auth-form.component.html',
  styleUrls: ['./emp-sep-auth-form.component.css']
})
export class EmpSepAuthFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }
  
}



// WEBPACK FOOTER //
// ./src/app/hrms/Employee-Separation/emp-sep-authorization/emp-sep-auth-form/emp-sep-auth-form.component.ts